import * as ReactGA from 'react-ga'

/**
 * Retrieves the Google Analytics tracking id from the Web Central server.
 * Initializes Google Analytics if the tracking id exists.
 * @returns {Promise<any>}
 */
export const initializeGoogleAnalytics = () => {
  return new Promise(function(resolve, reject) {
    const callbackHandler = trackingCode => {
      if (trackingCode) {
        ReactGA.initialize(trackingCode)
        ReactGA.pageview(window.location.pathname + window.location.search)
        resolve()
      } else {
        ReactGA.initialize('')
        resolve()
      }
    }
    let options = {
      async: true,
      headers: {'cache-control': 'no-cache'},
      callback: callbackHandler,
      errorHandler: function(exception, message) {
        reject(message)
      }
    }

    GoogleAnalyticsService.getTrackingId(options)
  })
}
